export const FoodTypes = Object.freeze([
  "BURGER",
  "PIZZA",
  "STEAK",
  "SALAD",
  "CAKE",
  "SANDWICH",
  "PASTA",
  "COCKTAIL",
  "BEER",
  "WINE",
  "COFFEE",
  "JUICE",
  "OTHER",
]);

export const standardSizes = {
  BURGER: { diameter: 12, height: 8 },
  PIZZA: { diameter: 30, height: 2 },
  STEAK: { length: 20, width: 15, height: 3 },
  SALAD: { diameter: 18, height: 5 },
  CAKE: { diameter: 20, height: 10 },
  SANDWICH: { length: 15, width: 10, height: 6 },
  PASTA: { diameter: 22, height: 4 },
  COCKTAIL: { diameter: 8, height: 12 },
  BEER: { diameter: 10, height: 15 },
  WINE: { diameter: 9, height: 20 },
  COFFEE: { diameter: 12, height: 10 },
  JUICE: { diameter: 10, height: 15 },
  OTHER: { length: 20, width: 20, height: 5 },
};

export const DietaryLabels = Object.freeze([
  "vegan",
  "vegetarian",
  "spicy",
  "gluten_free",
  "halal",
]);

export const getDimensionFieldsForFoodType = (type) => {
  switch (type) {
    case "STEAK":
    case "SANDWICH":
    case "OTHER":
      return ["length", "width", "height"];
    case "BURGER":
    case "PIZZA":
    case "PASTA":
    case "CAKE":
    case "SALAD":
    case "BEER":
    case "WINE":
    case "COFFEE":
    case "JUICE":
      return ["diameter", "height"];
    default:
      return ["diameter", "height"];
  }
};

export function mapUserDimensionsToXYZ(foodType, userDims = {}) {
  const { diameter, height, length, width } = userDims;

  const defaultDims = standardSizes[foodType] || {};

  // fallback dimensions
  const fallback = (dimName) => userDims[dimName] || defaultDims[dimName] || 10;

  switch (foodType) {
    case "BURGER":
    case "PIZZA":
    case "PASTA":
    case "CAKE":
    case "SALAD":
    case "BEER":
    case "WINE":
    case "COFFEE":
    case "JUICE":
      return {
        x: fallback("diameter"),
        y: fallback("height"),
        z: fallback("diameter"),
      };

    case "STEAK":
    case "SANDWICH":
    case "OTHER":
      return {
        x: fallback("length"),
        y: fallback("height"),
        z: fallback("width"),
      };
    default:
      return {
        x: fallback("diameter"),
        y: fallback("height"),
        z: fallback("diameter"),
      };
  }
}
